import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const location = useLocation();
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    console.log("click");
  };
  return (
    <>
      <header>
        <div class="rs-header-area rs-header-four has-theme-light-blue">
          <div class="container-fluid p-0">
            {/* <!-- top start --> */}
            <div class="rs-header-top rs-header-top-two">
              <div class="rs-header-info-wrapper">
                <div className="rs-header-info-item">
                  <div className="rs-header-info-inner">
                    <Link to={`mailto:${process.env.REACT_APP_EMAIL2}`}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3ZM20 7.23792L12.0718 14.338L4 7.21594V19H20V7.23792ZM4.51146 5L12.0619 11.662L19.501 5H4.51146Z"></path>
                      </svg>
                      {process.env.REACT_APP_EMAIL2}
                    </Link>
                  </div>
                </div>
                <div class="rs-header-info-item">
                  <div className="rs-header-info-inner">
                    <i className="fa-solid fa-phone"></i>
                    <Link
                      to={`tel:${process.env.REACT_APP_PHONE2}`}
                      title="pristine-mobile-number"
                    >
                      {process.env.REACT_APP_PHONE2}
                    </Link>
                    /
                    <Link
                      to={`tel:${process.env.REACT_APP_PHONE3}`}
                      title="pristine-mobile-number"
                    >
                      {process.env.REACT_APP_PHONE3}
                    </Link>
                  </div>
                </div>
                <div className="rs-header-info-item">
                  <div className="rs-header-info-inner">
                    <Link to="/">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="22"
                        viewBox="0 0 18 22"
                        fill="none"
                      >
                        <path
                          d="M9 18.8995L13.9497 13.9497C16.6834 11.2161 16.6834 6.78392 13.9497 4.05025C11.2161 1.31658 6.78392 1.31658 4.05025 4.05025C1.31658 6.78392 1.31658 11.2161 4.05025 13.9497L9 18.8995ZM9 21.7279L2.63604 15.364C-0.87868 11.8492 -0.87868 6.15076 2.63604 2.63604C6.15076 -0.87868 11.8492 -0.87868 15.364 2.63604C18.8787 6.15076 18.8787 11.8492 15.364 15.364L9 21.7279ZM9 11C10.1046 11 11 10.1046 11 9C11 7.89543 10.1046 7 9 7C7.8954 7 7 7.89543 7 9C7 10.1046 7.8954 11 9 11ZM9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9C13 11.2091 11.2091 13 9 13Z"
                          fill="#737373"
                        ></path>
                      </svg>
                      {process.env.REACT_APP_HEADER_ADDRESS}
                    </Link>
                  </div>
                </div>
              </div>

              <div class="rs-header-search-wrapper">
                <div class="rs-theme-social has-transparent has-theme-blue">
                  <Link to="https://www.linkedin.com/company/pristine-precision-tools/" title="pristine-linkedin-account">
                    <i className="ri-linkedin-fill"></i>
                  </Link>
                  <Link to="https://www.instagram.com/pristinetools.in?igsh=c3lodWg2dXZzc3V4" title="pristine-instagram-account">
                    <i className="ri-instagram-line"></i>
                  </Link>
                </div>
              </div>
            </div>
            {/* <!-- top end --> */}
          </div>
          <div class="container-fluid p-0">
            <div class="rs-header-inner" id="header-sticky">
              <div class="rs-header-left">
                <div class="rs-header-logo-wrapper">
                  <div class="rs-header-logo">
                    {/* <!-- <div class="rs-header-logo-bg"></div> --> */}
                    <Link to="/">
                      <img src="/assets/images/header.png" alt="logo" />
                    </Link>
                  </div>
                </div>
              </div>
              <div class="rs-header-menu">
                <nav id="mobile-menu" class="main-menu">
                  <ul className="multipage-menu">
                    <li className="menu-item-has-children">
                      <Link
                        to="/"
                        id={location.pathname === "/" ? "active" : ""}
                      >
                        Home
                      </Link>
                    </li>

                    <li className="menu-item-has-children">
                      <Link
                        to="/about"
                        id={location.pathname === "/about" ? "active" : ""}
                      >
                        About
                      </Link>
                    </li>

                    <li className="menu-item-has-children pe-5">
                      <Link
                        to="/product"
                        id={location.pathname === "/product" ? "active" : ""}
                        className="has-arrow2 pe-3"
                      >
                        Product
                      </Link>

                      <ul className="submenu last-children">
                        <li className="has-arrow">
                          <Link
                            to="/high-performance-drills"
                            title="pristine precision tools High-Performance-Drills"
                          >
                            High Performance Drills
                          </Link>
                          <ul className="submenu">
                            <li>
                              <Link to="/product/micro-drills-non-through-coolant">
                                Micro Drills Non Through Coolant
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/standard-drills-non-through-coolant">
                                Standard Drills Non Through Coolant
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/standard-drills-through-coolant">
                                Standard Drills Through Coolant
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/center-drills">
                                Central Drills
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li className="has-arrow">
                          <Link
                            to="/high-performance-endmills"
                            title="pristine precision tools High-Performance-Endmills page "
                          >
                            High Performance Endmills
                          </Link>
                          <ul className="submenu">
                             <li>
                              <Link to="/product/regular-endmills">
                                Regular Endmills
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/long-endmills">
                                Long Endmills
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/extra-long-endmills">
                                Extra Long Endmills
                              </Link>
                            </li>
                           

                            <li>
                              <Link to="/product/rougher-endmills">
                                Rougher Endmills
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/single-lip-endmills">
                                Single Lip Endmills
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/taper-stub-neck-endmill">
                                Taper/Stub Neck Endmill
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/3 fulte & 6 fulte-endmill">
                                3 Fulte & 6 Fulte Endmill
                              </Link>
                            </li>
                            <li>
                              <Link to="/product/corner-redius-endmills">
                                Corner-Redius-Endmills
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li className="">
                          <Link
                            to="/product/chamfer"
                            title="pristine precision tools Chamfer-Tools"
                          >
                            Chamfer Tools
                          </Link>
                          {/* <ul className="submenu">
                            <li>
                              <Link to="/product/chamfer">Chamfer</Link>
                            </li>
                          </ul> */}
                        </li>

                        <li className="">
                          <Link
                            to="/customized-tools"
                            title="pristine precision tools Customized-Tools"
                          >
                            Customized Tools
                          </Link>
                          {/* <ul className="submenu">
                            <li>
                              <Link to="/product/customized-tools">
                                Customized Tools
                              </Link>
                            </li>
                          </ul> */}
                        </li>

                        <li className="has-arrow">
                          <Link
                            to="/ballnose-endmills"
                            title="pristine precision tools Chamfer-Tools"
                          >
                            Ballnose Endmills
                          </Link>
                          <ul className="submenu">
                            <li>
                              <Link to="/product/regular-ballnose-endmills">
                                Regular Ballnose Endmills
                              </Link>
                            </li>

                            <li>
                              <Link to="/product/long-ballnose-endmills">
                                Long Ballnose Endmills
                              </Link>
                            </li>

                            <li>
                              <Link to="/product/extra-long-ballnose-endmills">
                                Extra Long Ballnose Endmills
                              </Link>
                            </li>
                          </ul>
                        </li>

                        <li className="">
                          <Link
                            to="/product/reamer"
                            title="pristine precision tools Chamfer-Tools"
                          >
                            Reamer
                          </Link>
                          {/* <ul className="submenu">
                            <li>
                              <Link to="/product/reamer">Reamer</Link>
                            </li>
                          </ul> */}
                        </li>
                      </ul>
                    </li>

                    {/* <!-- elements menu --> */}
                    <li className="has-mega-menu menu-item-has-children">
                      <Link
                        to="/certificate"
                        id={
                          location.pathname === "/certificate" ? "active" : ""
                        }
                      >
                        {" "}
                        Certificate
                      </Link>
                    </li>

                    <li className="menu-item-has-children">
                      <Link
                        to="/contact"
                        id={location.pathname === "/contact" ? "active" : ""}
                      >
                        Contact
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="rs-header-right">
                {/* <!-- soical area start --> */}
                {/* <div class="rs-header-search-wrapper">
                  <div class="rs-theme-social has-transparent has-theme-blue">
                    <a href="#">
                      <i class="ri-twitter-x-line"></i>
                    </a>
                    <a href="#">
                      <i class="ri-facebook-fill"></i>
                    </a>
                    <a href="#">
                      <i class="ri-linkedin-fill"></i>
                    </a>
                    <a href="#">
                      <i class="ri-instagram-line"></i>
                    </a>
                  </div>
                </div> */}
                {/* <!-- soical area end --> */}
                <div className="rs-header-btn">
                  <Link
                    className="rs-btn has-theme-red has-icon has-bg has-skew"
                    to="/assets/PDF/BROCHURE.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    DOWNLOAD BROCHURE
                    <span className="icon-box">
                      <i className="fa-solid fa-download"></i>
                    </span>
                  </Link>
                </div>

                <div className="rs-header-hamburger">
                  <div className="sidebar-toggle">
                    <button
                      className="bar-icon"
                      //   to="/"
                      onClick={(e) => {
                        e.preventDefault();
                        toggleSidebar();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                      >
                        <path
                          d="M8.55566 11H1.55566C1.29045 11 1.03609 11.1054 0.848557 11.2929C0.661021 11.4804 0.555664 11.7348 0.555664 12V19C0.555664 19.2652 0.661021 19.5196 0.848557 19.7071C1.03609 19.8946 1.29045 20 1.55566 20H8.55566C8.82088 20 9.07523 19.8946 9.26277 19.7071C9.45031 19.5196 9.55566 19.2652 9.55566 19V12C9.55566 11.7348 9.45031 11.4804 9.26277 11.2929C9.07523 11.1054 8.82088 11 8.55566 11ZM7.55566 18H2.55566V13H7.55566V18ZM19.5557 0H12.5557C12.2904 0 12.0361 0.105357 11.8486 0.292893C11.661 0.48043 11.5557 0.734784 11.5557 1V8C11.5557 8.26522 11.661 8.51957 11.8486 8.70711C12.0361 8.89464 12.2904 9 12.5557 9H19.5557C19.8209 9 20.0752 8.89464 20.2628 8.70711C20.4503 8.51957 20.5557 8.26522 20.5557 8V1C20.5557 0.734784 20.4503 0.48043 20.2628 0.292893C20.0752 0.105357 19.8209 0 19.5557 0ZM18.5557 7H13.5557V2H18.5557V7ZM19.5557 11H12.5557C12.2904 11 12.0361 11.1054 11.8486 11.2929C11.661 11.4804 11.5557 11.7348 11.5557 12V19C11.5557 19.2652 11.661 19.5196 11.8486 19.7071C12.0361 19.8946 12.2904 20 12.5557 20H19.5557C19.8209 20 20.0752 19.8946 20.2628 19.7071C20.4503 19.5196 20.5557 19.2652 20.5557 19V12C20.5557 11.7348 20.4503 11.4804 20.2628 11.2929C20.0752 11.1054 19.8209 11 19.5557 11ZM18.5557 18H13.5557V13H18.5557V18ZM8.55566 0H1.55566C1.29045 0 1.03609 0.105357 0.848557 0.292893C0.661021 0.48043 0.555664 0.734784 0.555664 1V8C0.555664 8.26522 0.661021 8.51957 0.848557 8.70711C1.03609 8.89464 1.29045 9 1.55566 9H8.55566C8.82088 9 9.07523 8.89464 9.26277 8.70711C9.45031 8.51957 9.55566 8.26522 9.55566 8V1C9.55566 0.734784 9.45031 0.48043 9.26277 0.292893C9.07523 0.105357 8.82088 0 8.55566 0ZM7.55566 7H2.55566V2H7.55566V7Z"
                          fill="#616161"
                        ></path>
                      </svg>
                    </button>
                  </div>
                </div>

                <div className="fix">
                  <div
                    className={`offcanvas-area has-theme-red ${
                      sidebarOpen ? "active" : ""
                    }`}
                    data-lenis-prevent
                  >
                    <div className="offcanvas-wrapper">
                      <div className="offcanvas-content">
                        <div className="offcanvas-top d-flex justify-content-between align-items-center mb-25">
                          <div className="offcanvas-logo">
                            <Link to="/">
                              <img
                                src="/assets/images/Pristing-precision-tool-header-logo.png"
                                alt="logo"
                              />
                            </Link>
                          </div>
                          <div className="offcanvas-close">
                            <button
                              className="offcanvas-close-icon animation--flip"
                              onClick={toggleSidebar}
                            >
                              <span className="offcanvas-m-lines">
                                <span className="offcanvas-m-line line--1"></span>
                                <span className="offcanvas-m-line line--2"></span>
                                <span className="offcanvas-m-line line--3"></span>
                              </span>
                            </button>
                          </div>
                        </div>
                        <div className="offcanvas-about mb-30 d-none d-sm-block">
                          <p>
                            {" "}
                            Industrie is a modern industrial website designed
                            for manufacturing units, construction companies, oil
                            & gas firms, architecture studios, and other growing
                            businesses.
                          </p>
                        </div>
                        <div className="offcanvas-gallery d-none d-sm-block">
                          <div className="offcanvas-gallery-thumb-wrapper">
                            <div className="offcanvas-popup-thumb">
                              <img
                                src="/assets/images/pristine-product/drills.png"
                                alt="image"
                              />
                            </div>
                            <div className="offcanvas-popup-thumb">
                              <img
                                src="/assets/images/pristine-product/Endmills.png"
                                alt="image"
                              />
                            </div>
                            <div className="offcanvas-popup-thumb">
                              <img
                                src="/assets/images/pristine-product/champer-tools.png"
                                alt="image"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mobile-menu">
                          <div className="rs-offcanvas-menu mb-25">
                            <nav></nav>
                          </div>
                        </div>
                        <div className="offcanvas-contact mb-30">
                          <h4 className="offcanvas-title-meta">Contact Info</h4>
                          <ul>
                            <li className="d-flex align-items-center gap-15">
                              <div className="offcanvas-contact-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="18"
                                  viewBox="0 0 14 18"
                                  fill="none"
                                >
                                  <path
                                    d="M11.8768 9.68475C11.3059 10.835 10.5331 11.9818 9.74128 13.0109C8.95198 14.0368 8.15999 14.9249 7.5643 15.5572C7.48514 15.6412 7.40956 15.7206 7.33802 15.7951C7.26648 15.7206 7.1909 15.6412 7.11174 15.5572C6.51605 14.9249 5.72406 14.0368 4.93476 13.0109C4.14299 11.9818 3.37019 10.835 2.79925 9.68475C2.22242 8.52266 1.89032 7.43373 1.89032 6.5C1.89032 3.50846 4.32934 1.08333 7.33802 1.08333C10.3467 1.08333 12.7857 3.50846 12.7857 6.5C12.7857 7.43373 12.4536 8.52266 11.8768 9.68475ZM7.33802 17.3333C7.33802 17.3333 13.8753 11.1732 13.8753 6.5C13.8753 2.91015 10.9484 0 7.33802 0C3.7276 0 0.800781 2.91015 0.800781 6.5C0.800781 11.1732 7.33802 17.3333 7.33802 17.3333Z"
                                    fill="#6D6D6D"
                                  ></path>
                                  <path
                                    d="M7.33802 8.66667C6.13455 8.66667 5.15894 7.69662 5.15894 6.5C5.15894 5.30338 6.13455 4.33333 7.33802 4.33333C8.54149 4.33333 9.5171 5.30338 9.5171 6.5C9.5171 7.69662 8.54149 8.66667 7.33802 8.66667ZM7.33802 9.75C9.14323 9.75 10.6066 8.29492 10.6066 6.5C10.6066 4.70507 9.14323 3.25 7.33802 3.25C5.53281 3.25 4.0694 4.70507 4.0694 6.5C4.0694 8.29492 5.53281 9.75 7.33802 9.75Z"
                                    fill="#6D6D6D"
                                  ></path>
                                </svg>
                              </div>
                              <div className="offcanvas-contact-text">
                                <Link
                                  to="/"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      process.env.REACT_APP_OFFCANVAS_ADDRESS,
                                  }}
                                />
                              </div>
                            </li>
                            <li className="d-flex align-items-center gap-15">
                              <div className="offcanvas-contact-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M3.65387 1.32849C3.40343 1.00649 2.92745 0.976861 2.639 1.26531L1.60508 2.29923C1.1216 2.78271 0.94387 3.46766 1.1551 4.06847C2.00338 6.48124 3.39215 8.74671 5.32272 10.6773C7.25329 12.6078 9.51876 13.9966 11.9315 14.8449C12.5323 15.0561 13.2173 14.8784 13.7008 14.3949L14.7347 13.361C15.0231 13.0726 14.9935 12.5966 14.6715 12.3461L12.3653 10.5524C12.2008 10.4245 11.9866 10.3793 11.7845 10.4298L9.59541 10.9771C9.00082 11.1257 8.37183 10.9515 7.93845 10.5181L5.48187 8.06155C5.04849 7.62817 4.87427 6.99919 5.02292 6.40459L5.57019 4.21553C5.62073 4.01336 5.57552 3.79918 5.44758 3.63468L3.65387 1.32849ZM1.88477 0.511076C2.62689 -0.231039 3.8515 -0.154797 4.49583 0.673634L6.28954 2.97983C6.6187 3.40304 6.73502 3.95409 6.60498 4.47423L6.05772 6.66329C5.99994 6.8944 6.06766 7.13888 6.2361 7.30732L8.69268 9.7639C8.86113 9.93235 9.1056 10.0001 9.33671 9.94229L11.5258 9.39502C12.0459 9.26499 12.597 9.3813 13.0202 9.71047L15.3264 11.5042C16.1548 12.1485 16.231 13.3731 15.4889 14.1152L14.455 15.1492C13.7153 15.8889 12.6089 16.2137 11.5778 15.8512C9.01754 14.9511 6.61438 13.4774 4.56849 11.4315C2.5226 9.38562 1.04895 6.98246 0.148838 4.42225C-0.213682 3.39112 0.11113 2.28472 0.85085 1.545L1.88477 0.511076Z"
                                    fill="#6D6D6D"
                                  ></path>
                                  <path
                                    d="M11 0.5C11 0.223858 11.2239 0 11.5 0H15.5C15.7761 0 16 0.223858 16 0.5V4.5C16 4.77614 15.7761 5 15.5 5C15.2239 5 15 4.77614 15 4.5V1.70711L10.8536 5.85355C10.6583 6.04882 10.3417 6.04882 10.1464 5.85355C9.95118 5.65829 9.95118 5.34171 10.1464 5.14645L14.2929 1H11.5C11.2239 1 11 0.776142 11 0.5Z"
                                    fill="#6D6D6D"
                                  ></path>
                                </svg>
                              </div>
                              <div className="offcanvas-contact-text">
                                <Link
                                  to={`tel:${process.env.REACT_APP_PHONE2}`}
                                >
                                  {process.env.REACT_APP_PHONE2}{" "}
                                </Link>
                              </div>
                            </li>
                            <li className="d-flex align-items-center gap-15">
                              <div className="offcanvas-contact-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                >
                                  <path
                                    d="M2 2C0.895431 2 0 2.89543 0 4V12L2.58386e-05 12.0103C0.00555998 13.1101 0.898859 14 2 14H7.5C7.77614 14 8 13.7761 8 13.5C8 13.2239 7.77614 13 7.5 13H2C1.53715 13 1.14774 12.6855 1.03376 12.2586L6.67417 8.7876L8 9.5831L15 5.3831V8.5C15 8.77614 15.2239 9 15.5 9C15.7761 9 16 8.77614 16 8.5V4C16 2.89543 15.1046 2 14 2H2ZM5.70808 8.20794L1 11.1052V5.3831L5.70808 8.20794ZM1 4.2169V4C1 3.44772 1.44772 3 2 3H14C14.5523 3 15 3.44772 15 4V4.2169L8 8.4169L1 4.2169Z"
                                    fill="#6D6D6D"
                                  ></path>
                                  <path
                                    d="M14.2467 14.2686C15.2567 14.2686 15.8339 13.4116 15.8339 12.2442V12.0344C15.8339 10.4297 14.6402 9 12.5197 9H12.4847C10.421 9 9 10.3598 9 12.4322V12.6465C9 14.8195 10.4385 16 12.3579 16H12.4016C12.9963 16 13.4204 15.9257 13.639 15.8251V15.0949C13.3941 15.2042 12.9656 15.2742 12.4585 15.2742H12.4147C11.0812 15.2742 9.84385 14.4872 9.84385 12.6202V12.4628C9.84385 10.8057 10.9019 9.73891 12.4847 9.73891H12.524C14.0587 9.73891 15.0075 10.7883 15.0075 12.065V12.183C15.0075 13.158 14.6839 13.5734 14.3691 13.5734C14.1374 13.5734 13.9582 13.4247 13.9582 13.1537V10.9631H13.0531V11.5315H13.0225C12.9394 11.2342 12.6552 10.9019 12.0693 10.9019C11.2911 10.9019 10.8101 11.4572 10.8101 12.3011V12.8301C10.8101 13.722 11.2998 14.2642 12.0693 14.2642C12.5415 14.2642 12.9656 14.0369 13.0837 13.6215H13.1274C13.2455 14.0412 13.7439 14.2686 14.2467 14.2686ZM11.7939 12.6814V12.4541C11.7939 11.9076 12.0212 11.6627 12.3666 11.6627C12.664 11.6627 12.9394 11.8551 12.9394 12.371V12.7383C12.9394 13.3111 12.6858 13.4816 12.3754 13.4816C12.0212 13.4816 11.7939 13.2673 11.7939 12.6814Z"
                                    fill="#6D6D6D"
                                  ></path>
                                </svg>
                              </div>
                              <div className="offcanvas-contact-text">
                                <Link
                                  to={`mailto:${process.env.REACT_APP_EMAIL2}`}
                                >
                                  {process.env.REACT_APP_EMAIL2}
                                </Link>
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div className="offcanvas-social">
                          <h4 className="offcanvas-title-meta">
                            Subscribe & Follow
                          </h4>
                          <ul>
                            <li>
                              <Link to="https://www.linkedin.com/company/pristine-precision-tools/">
                                <i className="fab fa-linkedin"></i>
                              </Link>
                            </li>
                            <li>
                              <Link to="https://www.instagram.com/pristinetools.in?igsh=c3lodWg2dXZzc3V4">
                                <i className="fa-brands fa-instagram"></i>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        <div className="rs-header-btn">
                          <Link
                            className="rs-btn has-theme-red has-icon has-bg has-skew"
                            to="/assets/PDF/BROCHURE.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            DOWNLOAD BROCHURE
                            <span className="icon-box">
                              <i className="fa-solid fa-download"></i>
                            </span>
                          </Link>
                        </div>
                        <div className="offcanvas-close">
                          <button
                            className="offcanvas-close-icon animation--flip"
                            onClick={toggleSidebar}
                          >
                            <span className="offcanvas-m-lines">
                              <span className="offcanvas-m-line line--1"></span>
                              <span className="offcanvas-m-line line--2"></span>
                              <span className="offcanvas-m-line line--3"></span>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="offcanvas-overlay"></div>
                <div className="offcanvas-overlay-white"></div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
